<template>
  <keep-alive>
    <div class="main-content">
      <h2>測試版</h2>
    </div>
  </keep-alive>
</template>

<script>
// import { mapState, mapActions} from "vuex";
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import { mapGetters } from 'vuex';

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'DashboardMain',
  data() {
    return {
    };
  },
  components: {
  },
  computed: {
    ... mapGetters('auth', ['hasToken', 'userData']),
    isAdmin() {
      return this.hasToken && this.userData.is_admin;
    },

  },
  async mounted() {

    if (!this.isAdmin) {
      this.$router.push({name: 'kegBatchIndex'});
    }
  },
  beforeDestroy() {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
</style>